import * as React from 'react';
import { Checkin } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';
import { HashRouter } from 'react-router-dom';

import theme from '../../theme/theme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';
import { RenderersProvider } from '@websky/core/src/renderProps';
import { izaviaRenderers } from '../renderProps';

const CheckinComponent: React.FC = () => {
	return (
		<HashRouter>
			<RenderersProvider value={izaviaRenderers}>
				<ThemeProvider value={theme}>
					<Head />
					<Checkin />
				</ThemeProvider>
			</RenderersProvider>
		</HashRouter>
	);
};

export default CheckinComponent;
